"use client";
import { Box, Typography, Container, Divider, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function TermsPage() {
  const navigate = useNavigate();

  return (
    <Container
      sx={{
        py: 5,
        maxWidth: "md",
      }}
    >
      <Typography variant="h4" fontWeight="bold" mb={2} textAlign="center">
        Terms & Conditions
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Box sx={{ fontSize: "1rem", lineHeight: 1.8, color: "text.secondary" }}>
        <Typography paragraph>
          Welcome to <b>Kalyani Matrimony</b>. By accessing or using our
          website, mobile app, or related services, you agree to abide by the
          following Terms and Conditions. Please read them carefully before
          registration or use.
        </Typography>

        <Typography variant="h6" mt={3}>
          1. Eligibility
        </Typography>
        <Typography paragraph>
          You must be at least 18 years old (for women) or 21 years old (for
          men) to register on this platform. By registering, you confirm that
          you meet the minimum legal age for marriage as per Indian law.
        </Typography>

        <Typography variant="h6" mt={3}>
          2. Account Creation
        </Typography>
        <Typography paragraph>
          You are responsible for maintaining the confidentiality of your
          account credentials. You agree to provide accurate, current, and
          complete information during registration. Any false or misleading
          information may result in termination of your account.
        </Typography>

        <Typography variant="h6" mt={3}>
          3. Member Conduct
        </Typography>
        <Typography paragraph>
          Users are expected to behave respectfully and responsibly. Any abusive
          language, spam messaging, fake profiles, or attempts to defraud other
          users will lead to immediate account suspension.
        </Typography>

        <Typography variant="h6" mt={3}>
          4. Profile Approval
        </Typography>
        <Typography paragraph>
          Every new profile undergoes a verification process. We reserve the
          right to edit, modify, or reject profiles that do not meet our
          guidelines or contain inappropriate content.
        </Typography>

        <Typography variant="h6" mt={3}>
          5. Payment and Subscription
        </Typography>
        <Typography paragraph>
          Certain premium features may require payment. All payments made are
          non-refundable once services have started. Kalyani Matrimony does not
          store any card or banking details on its servers.
        </Typography>

        <Typography variant="h6" mt={3}>
          6. Privacy and Data
        </Typography>
        <Typography paragraph>
          Your personal details will be handled in accordance with our{" "}
          <b>Privacy Policy</b>. We will never sell or misuse your data for
          unauthorized purposes.
        </Typography>

        <Typography variant="h6" mt={3}>
          7. Termination of Account
        </Typography>
        <Typography paragraph>
          Kalyani Matrimony reserves the right to suspend or terminate any
          account that violates our policies or is inactive for a long period.
          Users can also delete their accounts anytime via profile settings.
        </Typography>

        <Typography variant="h6" mt={3}>
          8. Limitation of Liability
        </Typography>
        <Typography paragraph>
          Kalyani Matrimony is not responsible for any direct, indirect, or
          consequential loss arising from communications or interactions between
          users. Members are advised to verify details before proceeding with
          any commitments.
        </Typography>

        <Typography variant="h6" mt={3}>
          9. Dispute Resolution
        </Typography>
        <Typography paragraph>
          Any dispute arising from the use of our services shall be subject to
          the jurisdiction of courts in Coimbatore, India.
        </Typography>

        <Typography variant="h6" mt={3}>
          10. Modification of Terms
        </Typography>
        <Typography paragraph>
          We reserve the right to change or update these Terms at any time
          without prior notice. Continued use of the platform implies acceptance
          of the revised Terms.
        </Typography>

        <Typography mt={4} fontStyle="italic">
          Last updated: October 2025
        </Typography>
      </Box>

      <Box textAlign="center" mt={4}></Box>
    </Container>
  );
}

export default TermsPage;
